import { TileLayer } from "react-leaflet";
import { LAYER_Z_INDEX } from "@/features/map/constants/layerZIndex";

/**
 * 地番レイヤーと法務省登記所備付地図の地番レイヤーを返すコンポーネント
 *
 * 法務省地番地図配信の開発サイト: https://api-docs.geospace.jp/api/WebManual/chibanapiH/chibanMapH
 */
export const GEOSPACE_CHIBAN_TILE_LAYER_NAME = "地番を表示する";
export const LEGAL_AFFAIRS_CHIBAN_TILE_LAYER_NAME =
  "法務省登記所備付地図の地番を表示する";

interface CommonChibanTileLayerProps {
  mapServiceAppId: string;
  checkedGeospace?: boolean;
  checkedLegalAffairs?: boolean;
}

export const GEOSPACE_CHIBAN_MIN_ZOOM = 7;
export const GEOSPACE_CHIBAN_MAX_ZOOM = 21;
const GEOSPACE_MAX_NATIVE_ZOOM = 21;
const GEOSPACE_MAX_ZOOM = 22;
const GEOSPACE_Z_INDEX = LAYER_Z_INDEX.GEOSPACE_CHIBAN;

export const LEGAL_AFFAIRS_CHIBAN_MIN_ZOOM = 17;
export const LEGAL_AFFAIRS_CHIBAN_MAX_ZOOM = 21;
const LEGAL_AFFAIRS_MAX_NATIVE_ZOOM = 21;
const LEGAL_AFFAIRS_Z_INDEX = LAYER_Z_INDEX.LEGAL_AFFAIRS_CHIBAN;

const GEOSPACE_CHIBAN_BASE_URL = "https://api-maptile.geospace.jp/chibanmap";
const LEGAL_AFFAIRS_CHIBAN_BASE_URL =
  "https://api-h-chiban.geospace.jp/api/maptile";

const CHIBAN_ATTRIBUTION = "Copyright© NTTインフラネット. All Rights Reserved.";

export const CommonChibanTileLayer: React.FC<CommonChibanTileLayerProps> = ({
  mapServiceAppId,
  checkedGeospace,
  checkedLegalAffairs,
}) => {
  const geospaceUrl = `${GEOSPACE_CHIBAN_BASE_URL}/${mapServiceAppId}/{z}/{y}/{x}.png`;
  const legalAffairsUrl = `${LEGAL_AFFAIRS_CHIBAN_BASE_URL}/${mapServiceAppId}/{z}/{y}/{x}.png`;

  return (
    <>
      {checkedGeospace && (
        <TileLayer
          url={geospaceUrl}
          minZoom={GEOSPACE_CHIBAN_MIN_ZOOM}
          maxZoom={GEOSPACE_MAX_ZOOM}
          maxNativeZoom={GEOSPACE_MAX_NATIVE_ZOOM}
          zIndex={GEOSPACE_Z_INDEX}
          attribution={CHIBAN_ATTRIBUTION}
        />
      )}
      {checkedLegalAffairs && (
        <TileLayer
          url={legalAffairsUrl}
          minZoom={LEGAL_AFFAIRS_CHIBAN_MIN_ZOOM}
          maxZoom={LEGAL_AFFAIRS_CHIBAN_MAX_ZOOM}
          maxNativeZoom={LEGAL_AFFAIRS_MAX_NATIVE_ZOOM}
          zIndex={LEGAL_AFFAIRS_Z_INDEX}
          attribution={CHIBAN_ATTRIBUTION}
        />
      )}
    </>
  );
};
